import { Component, Input, Output, EventEmitter, forwardRef, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'kt-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TextareaComponent), multi: true }]
})
export class TextareaComponent implements ControlValueAccessor {
  @Input() label = '';
  /** When set, clamps the label to this many lines and reserves that height, so labels of
   * differing length stay vertically aligned across a row of fields. Unset = natural height. */
  @Input() labelLines: number = null;
  @Input() placeholder = '';
  @Input() hint = '';
  @Input() errorMessage = '';
  /** How errorMessage is shown: 'inline' below the field (default, reserves layout space) or 'floating' as an overlay balloon that doesn't push content below. */
  @Input() errorDisplay: 'inline' | 'floating' = 'inline';
  /** Red error border without an error message (use errorMessage when you also want text below). */
  @Input() hasError = false;
  @Input() rows = 3;
  @Input() maxLength: number;
  @Input() showCharCount = false;
  @Input() autoResize = false;
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() required = false;

  @Output() inputBlur = new EventEmitter<void>();

  @ViewChild('textareaEl') textareaEl: ElementRef<HTMLTextAreaElement>;

  value = '';

  onChange = (_: any) => { };
  onTouched = () => { };

  get charCount(): number { return (this.value || '').length; }

  /** Programmatically focus the underlying textarea (parity with focusing a native element). */
  focus() { this.textareaEl?.nativeElement?.focus(); }

  writeValue(value: any) { this.value = value ?? ''; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean) { this.disabled = isDisabled; }

  onInputChange(event: Event) {
    const el = event.target as HTMLTextAreaElement;
    this.value = el.value;
    this.onChange(this.value);
    this.onTouched();
    if (this.autoResize) {
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 'px';
    }
  }

  onBlur() { this.onTouched(); this.inputBlur.emit(); }
}
